import {Component, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SubCbDto} from './sub-cb-service';
import {DepartmentDto, DepartmentService} from '../department/department-service';

@Component({
  selector: 'app-sub-cb-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './sub-cb-modal.html'
})
export class SubCbModal implements OnInit {
  @Input() subcb: SubCbDto | undefined;
  @Input() viewOnly = false;
  @Input() onSave?: (payload: any, isEditMode: boolean) => Promise<boolean>;

  private readonly departmentService = inject(DepartmentService);

  departments: DepartmentDto[] = [];
  subCbForm: FormGroup;
  isEditMode = false;
  submitted = false;
  isSubmitting = false;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.subCbForm = this.fb.group({
      id: [null],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      departmentId: [null, [Validators.required]],
      taxid: ['', [Validators.maxLength(13)]],
      refId: ['', [Validators.maxLength(255)]],
      address: [''],
      zipcode: ['', [Validators.maxLength(5)]],
      telephone: ['', [Validators.maxLength(255)]],
      fax: ['', [Validators.maxLength(255)]],
      lat: ['', [Validators.maxLength(255)]],
      lng: ['', [Validators.maxLength(255)]],
      ordering: [0, [Validators.max(32767)]],
      state: [1]
    });
  }

  ngOnInit(): void {
    this.departmentService.getActiveDepartments().subscribe(depts => {
      this.departments = depts;
    });

    if (this.subcb) {
      this.isEditMode = true;
      this.subCbForm.patchValue(this.subcb);
    } else {
      this.subCbForm.reset({ordering: 0, state: 1});
    }

    if (this.viewOnly) {
      this.subCbForm.disable();
    }
  }

  save(): void {
    if (this.viewOnly) {
      return;
    }
    this.submitted = true;
    if (this.subCbForm.invalid) {
      return;
    }
    void this.submitAndClose(this.subCbForm.value);
  }

  private async submitAndClose(payload: any): Promise<void> {
    if (!this.onSave) {
      this.activeModal.close(payload);
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    try {
      const isSuccess = await this.onSave(payload, this.isEditMode);
      if (isSuccess) {
        this.activeModal.close(payload);
      }
    } finally {
      this.isSubmitting = false;
    }
  }
}
